export const Horizontal = 'horizontal'

export const Vertical = 'vertical'
